import React, { useEffect, useRef, useState } from "react";
import radiators from "../../../../../assets/image/category/radiators.webp";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import gauge from "../../../../../assets/image/services/gauge.webp";
import coolantpooling from "../../../../../assets/image/services/coolantpooling.webp";
import burningcoolant from "../../../../../assets/image/services/burningcoolant.webp";
import radiators4 from "../../../../../assets/image/services/radiators4.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";

export default function Radiators() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <div className="overflow-hidden">
      {/* Radiators and Cooling  Services*/}

      <div className="text-black mx-auto">
        {/* Image Column (5/12 on large) */}
        <div className=" relative flex items-center ">
          <img
            className=" lg:h-[30rem]  md:w-full md:h-[25rem] h-[20rem] w-full object-cover"
            src={radiators}
            alt="cooling system"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/65 to-transparent"></div>
          <h3
            className={`text-white text-center font-bold  absolute lg:text-[3.6rem] md:text-[2.3rem] text-2xl mt-3 inset-0 flex justify-center items-center mb-20
           transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
          >
            Full-Service Radiator & Cooling System
          </h3>
          <div
            className={`w-full flex items-center absolute inset-0 justify-center mt-14
             transition-all duration-[950ms] delay-1000 ease-in-out
                ${isVisible
                ? "-translate-y-0 opacity-100"
                : "translate-y-5 opacity-0"
              }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="bg-orange-500 text-white px-6 py-3 rounded-full text-base sm:text-lg md:text-xl font-bold hover:bg-orange-600 hover:scale-105 transition-all shadow-md">
                          Schedule Your Transmission Service
                        </button> */}
              <MyButton
                text=" Radiator & Cooling  Service"
                className="bg-orange-500 text-white px-6 py-[13px] rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12 on large) */}
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] lg:py-[35px] md:py-[35px] py-4 lg:px-[11%] ">
          <div className="container mx-auto px-6 max-w-4xl  text-center">
            <p className="text-[1.3rem] lg:block md:block hidden text-gray-700 mb-6 leading-relaxed">
              Your engine thrives at the perfect temperature. The cooling system
              is the silent guardian of your vehicle’s performance, working
              behind the scenes to regulate heat and ensure every drive is
              smooth and safe. It prevents your engine from overheating, even in
              the most demanding conditions, allowing all components to operate
              efficiently.
            </p>
            <p className="text-[1.3rem] text-gray-700 mb-6   ">
              <strong className="text-gray-900">
                But when the cooling system falters, the consequences go beyond
                expensive.{""}
              </strong>
              {""} &nbsp; Overheating can lead to warped engine parts, or even
              complete engine failure. That’s why regular maintenance—like
              coolant flushes, hose inspections, and fluid level checks—is
              essential. A well-maintained cooling system not only extends your
              engine’s life but also saves you from costly repairs down the
              road.
            </p>
            {/* <ul className="text-xl ps-1">
              {[
                "Rising temperature gauge",
                "Coolant leaks",
                "Low Coolant Levels",
                "Overheating engine",
                "Burning coolant smell",
                "Frequent coolant refills",
              ].map((item, index) => (
                <li
                  key={index}
                  className="hover:text-blue-900 flex items-center mb-2"
                >
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className="text-white p-0.5" />
                  </span>
                  {item}
                </li>
              ))}
            </ul> */}
            <div
              className={`
           transition-all duration-[950ms] delay-[2700ms] ease-out
                ${isVisible
                  ? "-translate-y-0 opacity-100"
                  : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-white bg-orange-500 cursor-pointer flex items-center">
                  Book Now
                </button> */}

                <MyButton
                  text="Book Now"
                  className="mx-auto py-[9px] transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]">
        <div className="lg:py-[30px] md:py-[30px] py-2 container ">
          <h1 className="text-blue-900 font-bold text-[1.8rem] md:text-[2.6rem] lg:text-[3rem]  text-center mb-3">
            Expert Reliable Cooling System Service
          </h1>

          <p className="mb-3 lg:font-normal text-center text-[1.35rem]  lg:px-[10%] md:px-[0%]  lg:mt-5">
            Cooling system issues don’t wait—they escalate. A faulty thermostat,
            a compromised water pump, or a radiator can turn a simple commute
            into an emergency. Our technicians diagnose and resolve issues using
            industry-leading parts and diagnostics to restore peak .
          </p>

          <div className="flex justtify-center items-center lg:px-[5.4%] py-[1rem]  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={burningcoolant}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Leaks Lead{" "}
                      <span className="text-[#2772AD]">Overheating </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    What starts as a small puddle can lead to serious engine
                    trouble. Coolant leaks often indicate failing hoses, cracked
                    radiators, or worn seals—all of which can cause overheating.
                    Ignoring them risks major engine damage. Catching leaks
                    early keeps your system cool, your engine safe, and your
                    repair bills low.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[5%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem]  text-3xl   ">
                    <b>
                      Thermostat Matters{" "}
                      <span className="text-[#2772AD]">More</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Your thermostat does more than regulate engine temperature—it plays a critical role in protecting your engine. A malfunctioning thermostat can cause overheating and reduced fuel efficiency. Our technicians inspect its accuracy and responsiveness to ensure your engine maintains an optimal operating temperature. Reliable performance starts with a properly functioning thermostat.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={gauge}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={radiators4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl  ">
                    <b>
                      Heat Destroys{" "}
                      <span className="text-[#2772AD]">Engines</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Minor overheating may seem harmless, but repeated episodes
                    can lead to serious engine damage—especially warped heads
                    and blown gaskets. Heat weakens seals and turning small
                    problems into expensive repairs. Routine cooling system
                    checks catch early warning signs and keep your engine
                    protected .
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mb-[1.7rem]">
            <p className="mb- lg:font-normal text-[1.3rem]  text-center lg:px-[8%] md:px[8%] sm:px-2 ">
              Overheating is more than an inconvenience—it’s a warning. Protect
              your engine, preserve your fuel efficiency, and prevent costly
              breakdowns with expert cooling system care. Shop the best auto
              parts in Canada through Vancouver auto parts online store and get the
              right components for your vehicle without delays.{" "}
            </p>
            <div className="flex justify-center mt-3 transform transition-transform duration-500 hover:scale-105">
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer flex items-center">
                Book Now <FaArrowRight className="ml-2" />
              </button> */}

                <MyButton text="Book Now" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
